import moment from "moment";

export default function FormatDateDiff(date1, date2) {

    let diffDuration = moment.duration(moment(date2).diff(moment(date1)));

    if (diffDuration.months()) {
        let year = diffDuration.years() > 1 ? diffDuration.years() + ' years ' : diffDuration.years() + ' year ';
        let month = diffDuration.months() > 1 ? diffDuration.months() + ' months' : diffDuration.months() + ' month';
        return year + month;
    } else if (diffDuration.years()) {
        return diffDuration.years() > 1 ? diffDuration.years() + ' years' : diffDuration.years() + ' year';
    }
    return '';
}
